import React, { useEffect, useState } from "react";
import favoriteDone from "../../assets/images/dasboard/favorite-done.png";
import favoritePending from "../../assets/images/dasboard/favorite-pending.png";
import { useDispatch } from "react-redux";
import secureLocalStorage from "react-secure-storage";
import {
  POST_MEAL_LOG_ENDPOINT,
  PUT_MEAL_SELF_FAV_ENDPOINT,
} from "../../config/ApisCollection";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import MainBg from "../../components/Mainbg";
import { currentMonthYearDay } from "../../function/functions";

export default function MealCenterView({ mealChoosedData }) {
  const location = useLocation();
  let history = useNavigate();
  const accessToken = secureLocalStorage.getItem("accessToken");
  const [tabType, setTabType] = useState("ing");
  const [mealData, setMealData] = useState(location.state);
  const [dietIngredients, setDietIngredients] = useState({
    carbs: 0,
    protein: 0,
    fat: 0,
  });

  const menuOption = [];

  const currentMonthYearDay_Data = currentMonthYearDay();

  const postMealLog = async (receipeid) => {
    const date = currentMonthYearDay_Data?.formattedTodayDate;
    const day = currentMonthYearDay_Data?.currentDay;
    const dateDayString = `${date} ${day}`;

    // Encode to Base64
    const encoded = btoa(dateDayString);

    const post_body = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Date-Day": encoded,
        "Content-Type": "application/json",
      },
    };
    // console.log(post_body);
    const response = await axios.put(
      `${POST_MEAL_LOG_ENDPOINT}/${receipeid}/done`,
      {},
      post_body
    );
    if (response && response.status && response.status === 200) {
      // Create a copy of the current state
      const updatedMealData = {
        ...mealData,
      };
      // Toggle the isFavorite value
      updatedMealData.isAction = !updatedMealData.isAction;
      // Update the state with the modified data
      setMealData(updatedMealData);
      history("/mealdiet/meal-view", { state: updatedMealData }); // for Update current State
    }
  };

  const postMealFavorite = async (receipeid) => {
    const date = currentMonthYearDay_Data?.formattedTodayDate;
    const day = currentMonthYearDay_Data?.currentDay;
    const dateDayString = `${date} ${day}`;

    // Encode to Base64
    const encoded = btoa(dateDayString);

    const post_body = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Date-Day": encoded,
        "Content-Type": "application/json",
      },
    };
    // console.log(post_body);
    const response = await axios.put(
      `${PUT_MEAL_SELF_FAV_ENDPOINT}/${receipeid}/favorite`,
      {},
      post_body
    );
    if (response && response.status && response.status === 200) {
      // Create a copy of the current state
      const updatedMealData = {
        ...mealData,
      };
      // Toggle the isFavorite value
      updatedMealData.isFavorite = !updatedMealData.isFavorite;
      // Update the state with the modified data
      setMealData(updatedMealData);
      history("/mealdiet/meal-view", { state: updatedMealData }); // for Update current State
    }
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // Adds smooth scrolling
    });
  }, [tabType]);

  // console.log(mealData);

  useEffect(() => {
    setMealData(mealData);

    let carbs = 0;
    let protein = 0;
    let fat = 0;
    mealData?.dietIngredients?.forEach((row, index) => {
      carbs += row?.nutrientsCarbs;
      fat += row?.nutrientsFat;
      protein += row?.nutrientsProtein;
    });

    setDietIngredients({
      carbs: carbs.toFixed(2),
      protein: protein.toFixed(2),
      fat: fat.toFixed(2),
    });

    window.scrollTo(0, 0);
  }, [mealData]);

  return (
    <MainBg>
      <div className="flex justify-center ">
        <div className="lg:w-2/6 md:w-1/2 sm:w-1/2 w-full h-full justify-center">
          <div className="w-full flex mb-1">
            <div className="w-full flex justify-between">
              <div className="w-full flex">
                <b className="font-2xl">Recipe</b>
              </div>
              <div
                onClick={() => {
                  postMealFavorite(mealData?.id);
                }}
                className="cursor-pointer"
              >
                <img
                  src={
                    mealData?.isFavorite === false
                      ? favoritePending
                      : favoriteDone
                  }
                />
              </div>
            </div>
          </div>
          <div className="flex justify-center flex-col gap-2 mt-2 w-11/12 mx-auto pb-20">
            <div className="border border-[#23B3F1] bg-[#E2F6FF] rounded-2xl px-3 pb-6 pt-2 flex justify-center text-center">
              <img
                src={mealData?.picture || mealData?.thumbnail}
                className="w-1/2 rounded-full h-1/2 shadow-lg shadow-[#00000082]"
                height={200}
                width={200}
              />
            </div>

            {mealData?.isAction && (
              <div
                className={`flex  justify-center py-2.5 px-3 items-center gap-3 -mt-[25px] rounded-2xl w-9/12 mx-auto shadow-lg shadow-[#eee] ${
                  mealData?.isAction !== "pending"
                    ? "border border-[#ff994f] bg-[#ff994f]"
                    : " cursor-pointer bg-white"
                }`}
              >
                <p
                  className="text-xs"
                  onClick={() => {
                    postMealLog(mealData?.id);
                  }}
                >
                  <i
                    className={
                      mealData?.isAction === "pending"
                        ? "fa fa-clock-o"
                        : "fa fa-check"
                    }
                  ></i>{" "}
                  {mealData?.isAction === "pending"
                    ? "Tap to log this meal"
                    : "You have logged this meal"}
                </p>
              </div>
            )}

            <h1 className="text-capitalize text-xl font-semibold mt-2">
              {mealData?.dietTitle}
            </h1>

            <div className="fasweekdes  ">
              <div className="nutbotmbox">
                <div className="nutbotmbox1">
                  <div className="nutbotmbox1tex">
                    <p>carbs</p>
                  </div>
                </div>
                <div className="tabroe1">
                  <div className="nutbotmtex mb-2">
                    <p>{dietIngredients?.carbs}</p>
                  </div>
                  <div className="modesutit1">
                    <p>gm</p>
                  </div>
                  <div className="nutbarnotfill">
                    <div
                      className={`nutbarfill `}
                      style={{
                        width: `${dietIngredients?.carbs}%`,
                      }}
                    />
                  </div>
                </div>
              </div>
              <div
                className="nutbotmbox"
                style={{
                  border: "2px solid rgba(88, 85, 158, 0.30)",
                }}
              >
                <div
                  className="nutbotmbox1"
                  style={{
                    background: "rgba(88, 85, 158, 0.10)",
                  }}
                >
                  <div
                    className="nutbotmbox1tex"
                    style={{
                      color: "#58559E",
                    }}
                  >
                    <p>proteins</p>
                  </div>
                </div>
                <div className="tabroe1">
                  <div className="nutbotmtex mb-2">
                    <p>{dietIngredients?.protein}</p>
                  </div>
                  <div className="modesutit1">
                    <p>gm</p>
                  </div>
                  <div className="nutbarnotfill">
                    <div
                      className={`nutbarfill`}
                      style={{
                        background: "#58559E",
                        width: `${dietIngredients?.protein}%`,
                      }}
                    />
                  </div>
                </div>
              </div>
              <div
                className="nutbotmbox"
                style={{
                  border: "2px solid rgba(255, 153, 80, 0.30)",
                }}
              >
                <div
                  className="nutbotmbox1"
                  style={{
                    background: "rgba(255, 153, 80, 0.10)",
                  }}
                >
                  <div
                    className="nutbotmbox1tex"
                    style={{
                      color: "#FF9950",
                    }}
                  >
                    <p>fats</p>
                  </div>
                </div>
                <div className="tabroe1">
                  <div className="nutbotmtex mb-2">
                    <p>{dietIngredients?.fat}</p>
                  </div>
                  <div className="modesutit1">
                    <p>gm</p>
                  </div>
                  <div className="nutbarnotfill">
                    <div
                      className={`nutbarfill`}
                      style={{
                        background: "#FF9950",
                        width: `${dietIngredients?.fat}%`,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="border mt-2 border-[#23B3F1] bg-[#fff] rounded-3xl px-3 py-4 text-justify">
              <strong>Description :- </strong>
              <div className="flex justify-center gap-5">
                <div
                  dangerouslySetInnerHTML={{
                    __html: mealData?.dietDescription,
                  }}
                  className="text-[12px]"
                />
              </div>
              <div className="flex gap-3 mt-5">
                <div
                  className={`${
                    tabType === "ing"
                      ? "bg-[#FF9950] text-white"
                      : "border border-[#ff99504d]"
                  } flex gap-2 rounded items-cente  px-2 py-1`}
                  onClick={() => {
                    setTabType("ing");
                  }}
                >
                  {/* <div className="w-2 h-2 rounded-full bg-[#FFEDE0]"></div> */}
                  <span className="text-[10px] font-semibold cursor-pointer">
                    Ingredients
                  </span>
                </div>
                <div
                  className={`${
                    tabType === "ins"
                      ? "bg-[#FF9950] text-white"
                      : "border border-[#ff99504d]"
                  } flex gap-2 rounded items-cente  px-2 py-1`}
                  onClick={() => {
                    setTabType("ins");
                  }}
                >
                  {/* <div className="w-2 h-2 rounded-full bg-[#FF9950]"></div> */}
                  <span className="text-[10px] font-semibold cursor-pointer">
                    Instructions
                  </span>
                </div>
                <div
                  className={`${
                    tabType === "nut"
                      ? "bg-[#FF9950] text-white"
                      : "border border-[#ff99504d]"
                  } flex gap-2 rounded items-cente  px-2 py-1`}
                  onClick={() => {
                    setTabType("nut");
                  }}
                >
                  {/* <div className="w-2 h-2 rounded-full bg-[#FF9950]"></div> */}
                  <span className="text-[10px] font-semibold cursor-pointer">
                    Nutrition
                  </span>
                </div>
              </div>

              <div className=" bg-white justify-center py-2.5 px-3 items-center gap-3 mt-3 rounded-2xl w-full mx-auto">
                {tabType === "ins" ? (
                  <>
                    {" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: mealData?.dietinstruction,
                      }}
                      className="text-[12px]"
                    />
                  </>
                ) : tabType === "nut" ? (
                  <>
                    <div className="flex justify-center gap-2 flex-col mt-3">
                      {mealData?.dietIngredients?.map((item, index) => (
                        <div
                          key={index}
                          className={`${
                            item?.title
                              ? " px-2.5 py-2.5  items-center border-b border-dotted text-[#555] text-left "
                              : ""
                          }`}
                        >
                          <p className="font-bold text-capitalize text-[14px] ">
                            {item.title}
                          </p>
                          <ul className=" text-xs text-capitalize text-[8px] indent-8 mt-2">
                            <li className="flex justify-between">
                              Calories <span>{item.calorie} Kcal</span>
                            </li>
                            <li className="flex justify-between">
                              Protein <span>{item.nutrientsProtein} gm</span>
                            </li>
                            <li className="flex justify-between">
                              Fat <span>{item.nutrientsFat} gm</span>
                            </li>
                            <li className="flex justify-between">
                              Carbohydrates
                              <span>{item.nutrientsCarbs} gm</span>{" "}
                            </li>
                          </ul>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <div className="flex justify-center gap-2 flex-col mt-3">
                    {mealData?.dietIngredients?.map((item, index) => (
                      <div
                        key={index}
                        className={`${
                          item?.title
                            ? " px-2.5 py-2.5 flex  items-center rounded-lg bg-[#FFEDE0] text-[#FE7701] text-left"
                            : ""
                        }`}
                      >
                        <p className="text-xs text-capitalize text-[8px] ">
                          {item.title}
                        </p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainBg>
  );
}
